// extracted by mini-css-extract-plugin
module.exports = {"vedaRetryContainer":"_7TEzT","vedaRetryContainer--leftColumn":"_2UxCZ","vedaRetryContainer--rightColumn":"_1GisA","divider":"Zlx3f"};